export const packageConst = {
  appName: '@krishanmadan/frontend',
  appVersion: '1.0.1',
};
